<mat-toolbar>
  Buscar albarán
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Limpiar búsqueda" (click)="clearAlbaran(); dataSource.data = []; hasSearched = false">
    <mat-icon color="primary">refresh</mat-icon>
  </button>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class='searchBox'>
  <mat-card class='searchCard'>
    <mat-form-field class="search-form-field" appearance="fill">
      <mat-label>Nº Albarán</mat-label>
      <input matInput type="number" [(ngModel)]="albaran" (keydown)="onSearchKeydown($event)">
      @if (albaran) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearAlbaran()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="searchAlbaran()">
      <mat-icon>search</mat-icon> Buscar
    </button>
  </mat-card>
</div>

<div class="pageContent">
  @if (hasSearched) {
    <mat-form-field class='buscarInput searchMobile'>
      <mat-label>Filtrar resultados</mat-label>
      <input matInput type="text" [(ngModel)]="filter" placeholder="" (keyup)="applyFilter($event)">
    </mat-form-field>
  }
  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef> Tipo </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)"> {{tipoLabel(element)}} </td>
      </ng-container>
      <ng-container matColumnDef="albaran">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº Albarán </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)"> {{element.albaran}} </td>
      </ng-container>
      <ng-container matColumnDef="fechaInicio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha inicio </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          {{element.fechaInicio}}
          @if (element.type === 'pesaje') {
            <span>h.</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="fechaFin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha final </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          {{element.fechaFin}}
          @if (element.type === 'pesaje') {
            <span>h.</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="transportistas">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Transportistas </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          @if (element.type === 'pesaje') {
            <span>{{element.transportistas}}</span>
          } @else {
            <span>-</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="matriculas">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Matrículas / Contenedores </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          @if (element.type === 'pesaje') {
            <span>{{element.matriculas}}</span>
          }
          @if (element.type === 'movement') {
            @if (element.typeMovement === 'entrega') {
              <mat-icon class='green miniIcon' matTooltip="Entrega">arrow_forward</mat-icon>
              <span>{{element.transportistas}}</span>
            }
            @if (element.typeMovement === 'retirada') {
              <mat-icon class='green miniIcon' matTooltip="Retirada">arrow_back</mat-icon>
              <span>{{element.matriculas}}</span>
            }
            @if (element.typeMovement === 'cambio') {
              <mat-icon class='green miniIcon' matTooltip="Entrega">arrow_forward</mat-icon>
              <span>{{element.transportistas}}</span>
              <br>
              <mat-icon class='orange miniIcon' matTooltip="Retirada">arrow_back</mat-icon>
              <span>{{element.matriculas}}</span>
            }
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="clasificado">
        <th mat-header-cell *matHeaderCellDef> Clasificado </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          @if (element.clasificado === 'true') {
            <mat-icon class='green' matTooltip="Clasificado">fiber_manual_record</mat-icon>
          }
          @if (element.clasificado === 'false') {
            <mat-icon class='red' matTooltip="Sin clasificar">fiber_manual_record</mat-icon>
          }
          @if (element.clasificado !== 'true' && element.clasificado !== 'false') {
            <span>-</span>
          }
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="7">
          @if (!hasSearched) {
            Introduce un número de albarán y pulsa Buscar.
          } @else {
            No existen registros para este albarán.
          }
        </td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  @if (hasSearched) {
    <mat-paginator [pageSize]="25" [pageSizeOptions]="pages" showFirstLastButtons></mat-paginator>
  }
</div>
